/** @jsxImportSource @emotion/react */

import { Button } from "antd";
import BusinessLicenseImg from "assets/desktop/images/footer/business-license.png";
import ResponsibilityImg from "assets/desktop/images/footer/responsibility.png";
import SecurityImg from "assets/desktop/images/footer/security.png";
import { FOOTER_LINKS } from "constants/footer";
import _map from "lodash/map";

import { AboutUsBlockStyle } from "./index.style";

const AboutUsBlock = () => {
  return (
    <div css={AboutUsBlockStyle.self}>
      <div css={AboutUsBlockStyle.box}>
        <h4 css={AboutUsBlockStyle.boxTitle}>Giấy phép kinh doanh</h4>
        <div css={AboutUsBlockStyle.boxContent}>
          <img src={BusinessLicenseImg} alt="" />
        </div>
      </div>
      <div css={AboutUsBlockStyle.box}>
        <h4 css={AboutUsBlockStyle.boxTitle}>An ninh bảo mật</h4>
        <div css={AboutUsBlockStyle.boxContent}>
          <img src={SecurityImg} alt="" />
        </div>
      </div>
      <div css={AboutUsBlockStyle.box}>
        <h4 css={AboutUsBlockStyle.boxTitle}>Theo dõi chúng tôi</h4>
        <div css={AboutUsBlockStyle.boxContent}>
          <div css={AboutUsBlockStyle.socials}>
            {_map(FOOTER_LINKS.socials, (item, index) => (
              <Button
                key={index}
                css={AboutUsBlockStyle.socialButton}
                type="text"
                shape="circle"
                icon={<item.name css={AboutUsBlockStyle.socialIcon} />}
                href={item.to}
              ></Button>
            ))}
          </div>
        </div>
      </div>
      <div css={AboutUsBlockStyle.box}>
        <h4 css={AboutUsBlockStyle.boxTitle}>Chơi có trách nhiệm</h4>
        <div css={AboutUsBlockStyle.boxContent}>
          <img src={ResponsibilityImg} alt="" />
        </div>
      </div>
    </div>
  );
};

export default AboutUsBlock;
